import _defineProperty from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _STANDARD_ERROR_MAP;

export var PARSE_ERROR = "PARSE_ERROR";
export var INVALID_REQUEST = "INVALID_REQUEST";
export var METHOD_NOT_FOUND = "METHOD_NOT_FOUND";
export var INVALID_PARAMS = "INVALID_PARAMS";
export var INTERNAL_ERROR = "INTERNAL_ERROR";
export var SERVER_ERROR = "SERVER_ERROR";
export var RESERVED_ERROR_CODES = [-32700, -32600, -32601, -32602, -32603];
export var SERVER_ERROR_CODE_RANGE = [-32000, -32099];
export var STANDARD_ERROR_MAP = (_STANDARD_ERROR_MAP = {}, _defineProperty(_STANDARD_ERROR_MAP, PARSE_ERROR, {
  code: -32700,
  message: "Parse error"
}), _defineProperty(_STANDARD_ERROR_MAP, INVALID_REQUEST, {
  code: -32600,
  message: "Invalid Request"
}), _defineProperty(_STANDARD_ERROR_MAP, METHOD_NOT_FOUND, {
  code: -32601,
  message: "Method not found"
}), _defineProperty(_STANDARD_ERROR_MAP, INVALID_PARAMS, {
  code: -32602,
  message: "Invalid params"
}), _defineProperty(_STANDARD_ERROR_MAP, INTERNAL_ERROR, {
  code: -32603,
  message: "Internal error"
}), _defineProperty(_STANDARD_ERROR_MAP, SERVER_ERROR, {
  code: -32000,
  message: "Server error"
}), _STANDARD_ERROR_MAP);
export var DEFAULT_ERROR = SERVER_ERROR;